import { styled } from '@mui/material/styles';

import { MOBILE_CONTAINER_WIDTH } from '@mopla/constants';
import { getThemeColor, TMoplaColors } from '@mopla/mui';

export const RootMobile = styled('div', {
	shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: TMoplaColors }>(({ theme, variant }) => ({
	display: 'grid',
	gridTemplateRows: '1fr max-content',
	height: '100%',
	width: '100%',
	background: getThemeColor(variant, theme),
}));

export const RootDesktop = styled('div')(({ theme }) => ({
	display: 'grid',
	gridTemplateRows: 'max-content 1fr',
	gridTemplateColumns: '1fr',

	height: '100%',
	width: '100%',
	background: theme.palette.neutral[40],
}));

export const DesktopOverflowWrapper = styled('div')(() => ({
	display: 'grid',
	justifyItems: 'center',
	overflow: 'auto',
	padding: 24,
	boxSizing: 'border-box',

	width: '100%',
	height: '100%',
}));

export const DesktopContentContainer = styled('div')(() => ({
	display: 'grid',
	gridTemplateColumns: '1fr 348px',
	gridGap: 24,
	width: '100%',
	maxWidth: 976,
}));

export const DesktopSearchContainer = styled('div')(() => ({
	display: 'grid',
	gridTemplateRows: 'max-content max-content',
	gridGap: 32,
	height: '100%',
	width: '100%',
}));

export const DesktopCenteredRoot = styled('div', {
	shouldForwardProp: (prop) => prop !== 'variant',
})<{ variant: TMoplaColors }>(({ theme, variant }) => ({
	display: 'grid',
	gridTemplateRows: '1fr max-content',
	height: '100%',
	width: '100%',
	maxWidth: MOBILE_CONTAINER_WIDTH,
	margin: '0 auto',
	background: getThemeColor(variant, theme),
	boxShadow: '0px 0px 24px rgba(0, 0, 0, 0.12)',
}));
